import script from "./accordianItem.vue?vue&type=script&setup=true&lang=js"
export * from "./accordianItem.vue?vue&type=script&setup=true&lang=js"

import "./accordianItem.vue?vue&type=style&index=0&id=6f11ca8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f11ca8e"]])

export default __exports__